export enum RoomsFormTemplates {
  ROOMS = 'rooms',
  ROOM = 'room',
  GUESTS = 'guests',
}
